import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'

export interface ExportToExcelArgs {
  data: DataItem[]
  fileName: string
}
export interface DataItem {
  group: string
  name: string
  diff: number | null
  rank: number
  value: string
  performance?: string
  target?: string
}

export interface ExportTableArgs {
  headers: string[]
  rows: (string | number | null | undefined)[][]
  fileName: string
}

export const exportTableToExcel = async ({ headers, rows, fileName }: ExportTableArgs) => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('My Worksheet')

  const headerRow = worksheet.addRow(headers)
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, size: 14 }
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '90949C' } }
    cell.alignment = { horizontal: 'center' }
    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
  })

  rows.forEach((row) => {
    const newRow = worksheet.addRow(row)
    const firstCell = newRow.getCell(1)
    firstCell.font = { bold: true }
    firstCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '90949C' } }
    firstCell.alignment = { horizontal: 'center' }
    firstCell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
  })

  worksheet.columns.forEach((column) => {
    let maxLength = 0
    column.eachCell?.({ includeEmpty: true }, (cell) => {
      let textLength = cell.value?.toString().length || 0
      textLength += 2
      maxLength = Math.max(maxLength, textLength)
    })
    column.width = maxLength
  })

  try {
    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    saveAs(blob, `${fileName ?? 'export'}.xlsx`)
  } catch (error) {
    console.error('Error creating Excel file:', error)
  }
}

export const exportRankingDataToExcel = async ({ data, fileName }: ExportToExcelArgs) => {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet('My Worksheet')

  const headers = Object.keys(data[0])

  const headerRow = worksheet.addRow(headers)
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, size: 14 }
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '90949C' },
    }
    cell.alignment = { horizontal: 'center' }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }
  })

  data.forEach((row) => {
    const newRow = worksheet.addRow(Object.values(row))

    const firstCell = newRow.getCell(1)
    firstCell.font = { bold: true }
    firstCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '90949C' },
    }
    firstCell.alignment = { horizontal: 'center' }
    firstCell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }
  })

  worksheet.columns.forEach((column) => {
    let maxLength = 0
    column.eachCell?.({ includeEmpty: true }, (cell) => {
      let textLength = cell.value?.toString().length || 0
      textLength += 2
      maxLength = Math.max(maxLength, textLength)
    })
    column.width = maxLength
  })

  try {
    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    saveAs(blob, `${fileName ?? 'export'}.xlsx`)
  } catch (error) {
    console.error('Ошибка при создании Excel файла:', error)
  }
}
